<script>
//
// Destiny Cards AI Chat — admin API config.
//
// The chat app lives on its own origin with its own Postgres, so the users/feedback/sales
// pages read it through /api/admin/* endpoints there rather than the api.destinycards.com
// backend the rest of this tool uses.
//
// `key` must match ADMIN_API_KEY in the chat app's .env, and this tool's origin must be
// listed in its ADMIN_ALLOWED_ORIGINS. Both are read at BUILD time over there, so a key
// change needs a chat-app rebuild, not just a restart.
//
// NOTE: like the WooCommerce consumer key already inlined in CalendarDash.vue, this key
// ships in the built bundle and is readable by anyone who can load this tool. Keep the
// deployed dist/ behind HTTP Basic auth or an IP allowlist at the web server.
//
const ChatApi = {
  base: 'https://destinycards.ai',
  key: '67225fa047f3d6884f2af95318139ca0d6de8c67f46c037954e65ef3616fe4d6'
};

export default ChatApi;
</script>
